import { z } from "zod";

import {
  QUESTION_CHOICE_SELECTION_METHOD,
  QUESTION_TEXT_MAX_CHARACTERS,
  QUESTION_TYPE,
} from "../constants/supplementalQuestions";

export const supplementalQuestionTypesSchema = z.enum(QUESTION_TYPE);

export const addFreeTextQuestionSchema = z.object({
  type: z.literal(QUESTION_TYPE.FREE_TEXT),
  text: z
    .string()
    .min(1, "Question text is required")
    .max(QUESTION_TEXT_MAX_CHARACTERS, "Length exceeded"),
});

export const addMultipleChoiceQuestionSchema = z.object({
  type: z.literal(QUESTION_TYPE.MULTIPLE_CHOICE),
  text: z
    .string()
    .min(1, "Question text is required")
    .max(QUESTION_TEXT_MAX_CHARACTERS, "Length exceeded"),
  selectionMethod: z.enum(QUESTION_CHOICE_SELECTION_METHOD),
  choices: z
    .array(z.object({ label: z.string() }))
    .min(2, "At least two choices are required")
    .refine((choices) => choices.every((choice) => choice.label.length > 0), {
      message: "Choices cannot be empty",
    })
    .refine(
      (choices) => {
        const nonEmptyLabels = choices.map((choice) => choice.label);
        return new Set(nonEmptyLabels).size === nonEmptyLabels.length;
      },
      {
        message: "Choices must be unique",
      },
    ),
});

export const addYesNoQuestionSchema = z.object({
  type: z.literal(QUESTION_TYPE.YES_NO),
  text: z
    .string()
    .min(1, "Question text is required")
    .max(QUESTION_TEXT_MAX_CHARACTERS, "Length exceeded"),
});

export const addQuestionFormSchema = z.discriminatedUnion("type", [
  addFreeTextQuestionSchema,
  addMultipleChoiceQuestionSchema,
  addYesNoQuestionSchema,
]);

const editFreeTextSchema = addFreeTextQuestionSchema.extend({
  id: z.string(),
});

const editMultipleChoiceSchema = addMultipleChoiceQuestionSchema.extend({
  id: z.string(),
});

const editYesNoQuestionSchema = addYesNoQuestionSchema.extend({
  id: z.string(),
});

export const editQuestionFormSchema = z.discriminatedUnion("type", [
  editFreeTextSchema,
  editMultipleChoiceSchema,
  editYesNoQuestionSchema,
]);

export const yesNoChoicesSchema = z.tuple([z.literal("yes"), z.literal("no")]);
